import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { FormSelect } from 'components/molecules/FormSelect';

export const StyledLicenceWrapper = styled(Grid)`
  display: flex;
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px 20px 20px 32px;
  margin-bottom: 16px;
  row-gap: 12px;
`;

export const StyledLicenceWrapperNoResult = styled(Grid)`
  border: 1px solid ${colors.gray100};
  padding: 16px 10px;
  font-style: italic;
`;

export const StyledNameSection = styled(Typography)`
  color: ${colors.primary900};
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  width: 100%;
  border-radius: 4px;
  background-color: ${colors.primary15};
  padding: 13px 24px;
  margin: 24px 0;
`;

export const StyledLink = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${colors.primary500};
  cursor: pointer;
  margin-bottom: 5px;
`;

export const StyledPresetSelect = styled(FormSelect)`
  & .MuiOutlinedInput-root {
    height: 32px;
  }
`;

export const StyledAdvancedSearch = styled(Grid)`
  margin-top: 20px;
  margin-bottom: 5px;
  & .MuiGrid-item {
    padding-top: 0px;
  }
`;
